import React, {useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../../../modules/auth'
import {useContextFlag} from '../../../modules/catalogo/DataContext'
import {useIntl} from 'react-intl'

const ModalUserModule = () => {
  const intl = useIntl()
  const {currentUser, logout} = useAuth()

  const truncateText = (text: string, maxLength: number = 24): string => {
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text
  }

  const {idFlag, setIdFlag} = useContextFlag()

  useEffect(() => {
    // console.log(currentUser)
  }, [idFlag])

  return (
    <div className='dropdown'>
      <button
        className='btn dropdown-toggle-icon-none px-3'
        type='button'
        data-bs-toggle='dropdown'
        aria-expanded='false'
      >
        <div className='symbol symbol-40px'>
          <img
            alt='avatar'
            src={
              currentUser?.registro.FotoPerfilUrl
                ? currentUser?.registro.FotoPerfilUrl
                : toAbsoluteUrl('/media/avatars/blank.png')
            }
          />
        </div>
      </button>

      <div className='dropdown-menu'>
        <div className='menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px '>
          <div className='menu-item px-3'>
            <div className='menu-content d-flex align-items-center px-3'>
              <div className='symbol symbol-50px me-5'>
                <img
                  alt='Logo'
                  src={
                    currentUser?.registro.FotoPerfilUrl
                      ? currentUser?.registro.FotoPerfilUrl
                      : toAbsoluteUrl('/media/avatars/blank.png')
                  }
                />
              </div>

              <div className='d-flex flex-column'>
                <div className='fw-bolder d-flex align-items-center fs-5'>
                  {currentUser?.registro.Nombres}
                </div>
                <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
                  {truncateText(currentUser?.registro.Email || '')}
                </a>
              </div>
            </div>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-5'>
            <a onClick={logout} className='menu-link px-5'>
              {intl.formatMessage({id: 'SIGN_OUT'})}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalUserModule
